/* eslint-disable react/forbid-dom-props */
import React, { useEffect, useState } from 'react';
import { usersApi } from '../services/api';

export default function UserAvatar({ user, size = 28 }) {
  const [url, setUrl] = useState('');
  const initials = (user?.name || 'U').slice(0, 2).toUpperCase();

  useEffect(() => {
    let alive = true;
    let objectUrl = '';
    if (!user?.id || !user?.has_avatar) {
      setUrl('');
      return undefined;
    }
    usersApi.getAvatarBlob(user.id)
      .then(blob => {
        if (!alive) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => setUrl(''));
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [user?.id, user?.has_avatar]);

  const style = {
    width: size,
    height: size,
    borderRadius: '50%',
    background: 'var(--navy)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size <= 28 ? '.68rem' : '.8rem',
    color: '#fff',
    fontWeight: 700,
    flexShrink: 0,
    overflow: 'hidden',
  };

  if (url) {
    return <img src={url} alt={user?.name || 'Usuário'} style={{ ...style, objectFit: 'cover' }} />;
  }
  return <div style={style}>{initials}</div>;
}
